<div class="custom-modal">
    <div class="custom-modal-container">
        <div class="modal-header">
            <h3 class="modal-title">
                Platform Upgrade Ready – Build {{ newVersionConfirmationService.version | async }}
            </h3>
            <button class="modal-close" (click)="onCancel()">×</button>
        </div>
        <div class="modal-body">
            SAL Onboarding has evolved. Refreshing to sync you with the next-generation experience.
        </div>

        <div class="modal-footer">
            <button type="button"
                    class="card-action"
                    (click)="confirm()">Confirm
            </button>
        </div>
    </div>
</div>
